// frontend/src/components/common/CompareFloatingBar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useCompare } from '../../context/CompareContext';
import { FaTimes, FaArrowRight } from 'react-icons/fa';

function CompareFloatingBar() {
  const { compareList, removeFromCompare, clearCompare } = useCompare();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-16 md:bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-4px_15px_rgba(0,0,0,0.1)] z-50 animate-fadeInUp p-3 md:p-4">
      <div className="container mx-auto max-w-6xl flex items-center justify-between">
        
        {/* Left: Selected Items */}
        <div className="flex items-center gap-3 overflow-x-auto pb-1 md:pb-0 no-scrollbar">
          
          {/* Counter Badge */}
          <div className="flex items-center gap-2 text-gray-600 font-bold text-sm whitespace-nowrap mr-1">
            <span className="bg-blue-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs shadow-sm">
              {compareList.length}
            </span>
            <span className="hidden sm:inline">Selected</span>
          </div>

          {/* Thumbnails */}
          {compareList.map((vehicle) => (
            <div key={vehicle.id} className="relative group flex-shrink-0">
              <div className="w-10 h-10 md:w-14 md:h-14 rounded-md border border-gray-300 overflow-hidden bg-gray-100">
                <img 
                  src={vehicle.image || 'https://via.placeholder.com/100'} 
                  alt={vehicle.model} 
                  className="w-full h-full object-cover"
                />
              </div>
              <button 
                onClick={() => removeFromCompare(vehicle.id)}
                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-0.5 shadow-md md:opacity-0 md:group-hover:opacity-100 transition-opacity"
                title="Remove"
              >
                <FaTimes size={8} />
              </button>
            </div>
          ))}
          
          {/* Placeholder for empty slots */}
          {compareList.length < 3 && (
             <div className="w-10 h-10 md:w-14 md:h-14 rounded-md border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 text-[10px] text-center p-1 bg-gray-50">
                 <span className="hidden md:inline">Add</span> +
             </div>
          )}
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-3 pl-3 border-l border-gray-200 ml-2">
          <button 
            onClick={clearCompare}
            className="text-gray-400 hover:text-red-500 text-xs font-medium hidden md:block"
          >
            Clear
          </button>
          
          <Link 
            to="/compare"
            className={`bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 md:px-6 md:py-2.5 rounded-full font-bold text-xs md:text-sm flex items-center gap-2 shadow-md transition-transform active:scale-95 ${compareList.length < 2 ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}
          >
            Compare <FaArrowRight />
          </Link>
        </div>

      </div>
    </div>
  );
}

export default CompareFloatingBar;